
import React from 'react';
import { format } from 'date-fns';
import { Badge } from '@/components/ui/badge';
import { CalendarEvent } from '@/hooks/use-chart-data';
import { getProductColor } from '@/utils/colorUtils';

interface UpcomingHarvestsListProps {
  monthEvents: CalendarEvent[];
}

export const UpcomingHarvestsList: React.FC<UpcomingHarvestsListProps> = ({ monthEvents }) => {
  return (
    <div className="mt-4">
      <h3 className="font-medium mb-2">Upcoming Harvests This Month</h3>
      {monthEvents.length > 0 ? (
        <div className="space-y-2">
          {monthEvents.map(event => (
            <div key={event.id} className="flex items-center p-2 rounded-md border">
              <div 
                className="w-4 h-4 rounded-full mr-3"
                style={{ backgroundColor: getProductColor(event.product) }}
              />
              <div className="flex-1">
                <div className="font-medium">{event.product}</div>
                <div className="text-sm text-muted-foreground">
                  {format(new Date(event.date), 'MMM d, yyyy')} • {event.quantity}kg
                </div>
              </div>
              <div>
                <Badge variant={
                  event.status === 'planned' ? 'outline' : 
                  event.status === 'in_progress' ? 'secondary' : 
                  'default'
                }>
                  {event.status === 'planned' ? 'Planned' : 
                   event.status === 'in_progress' ? 'In Progress' : 
                   'Completed'}
                </Badge>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-4 text-muted-foreground">
          No harvests scheduled for this month
        </div>
      )}
    </div>
  );
};
